import React from "react";

const Dashboard = () => {
    return (<div>
        {/* <iframe width="1200" height="1200" src="https://datastudio.google.com/embed/reporting/86022de8-0b88-4d5b-aefa-f12830a5a80f/page/YeaqC" frameborder="0" style={{border:0}} allowfullscreen></iframe> */}
    </div>)
}

export default Dashboard;